import Flux from 'lib/flux';

export default Flux.createConstants({
  messages: ['SHOW_DATES', 'DATES_SHOWN', 'SHOW_FORM'],
});
